import { useEffect, useState } from 'preact/hooks';
import APIError from 'exceptions/APIError';
import Shipment from 'interfaces/PmParcel';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import { ptpCatchError } from 'services/sentry.services';
import { getOrderLineItems } from '../services';
import { OrderLineItemDTO } from '../interfaces/orderLineItem.interfaces';

export const useOrderLineItems = (orderId: string, shipment: Shipment) => {
  const [orderLineItems, setOrderLineItems] = useState<OrderLineItemDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const globalConfig = useGlobalConfigContext();

  useEffect(() => {
    // Fetch order line items data
    async function fetchShipmentData() {
      try {
        setLoading(true);
        const lineItems = await getOrderLineItems(
          orderId,
          globalConfig.organizationId,
        );
        setOrderLineItems(
          lineItems.filter((item) => item.shipmentPk !== shipment.id),
        );
      } catch (error) {
        if (!APIError.isApiError(error)) {
          console.error('[PTP] can not load order line items', error);
          ptpCatchError(error);
        }
      } finally {
        setLoading(false);
      }
    }

    if (globalConfig.id) {
      fetchShipmentData();
    }
  }, [orderId, globalConfig]);

  return {
    loading,
    orderLineItems,
  };
};
